import { KuposErrorSuccessModal, SvgHome } from '../../../common';
import React, { useState } from 'react';

// import ApiUrls from '../../../services/apiUrls';
import BankTransfer from './components/BankTransfer';
import CommonService from '../../../../services/commonService';
import Map from './components/Map';
import Steps from './components/Steps';
import SuccessModal from './components/SuccessModal';
import Tabs from './components/Tabs';
import ApiUrls from '../../../../services/apiUrls';

const Marker = ({ show }) => (
  <React.Fragment>
    <div className="marker">
      <SvgHome name="pin" />
    </div>
    <InfoWindow show={show} />
  </React.Fragment>
);

const InfoWindow = props =>
  props.show ? (
    <div className="info-window">
      <div className="marker-icon-name">
        <span className="marker-name">Caja Vecina</span>
      </div>
      <div className="marker-service">
        <span className="bold-text">Servicios:</span>
        <span>Recargas</span>
      </div>
      <div className="marker-service">
        <span className="bold-text">Direccion:</span>
        <span>Luis</span>
      </div>
      <div className="marker-service">
        <span className="bold-text">PasajeBus.com</span>
      </div>
      <div className="marker-service">
        <span className="bold-text">Codigo de comercio</span>
      </div>
      <button className="kupos-button">COMO LLEGAR?</button>
    </div>
  ) : null;

function RechargeWalletKuposPayRecharge(props) {
  const [selectedTab, setSelectedTab] = useState(props.profileData && props.profileData.is_kupos_pay_enabled ? 2 : 1);
  const [selectedView, setSelectedView] = useState('steps');
  const [center, setCenter] = useState({
    lat: 59.95,
    lng: 30.33,
  });
  const [myLocation, setMyLocation] = useState({
    lat: -33.4724728,
    lng: -70.9100195,
  });

  const [amountError, setAmountError] = useState(null);
  const [showModalInitial, setShowModalInitial] = useState(null);
  const [rechargeAmount, setRechargeAmount] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [transferStatus, setTransferStatus] = useState(null);
  const [modalBody, setModalBody] = useState(null);
  const [modalIcon, setModalIcon] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalSubtitle, setModalSubtitle] = useState(null);
  const [modalButtonText, setModalButtonText] = useState(null);

  console.log('props in profile++++++', props);

  const onTabChange = i => {
    setSelectedTab(i);
  };

  const showMap = () => {
    setSelectedView('map');
  };

  const goToMap = () => {
    setShowModalInitial(false);
    let data = { amount: rechargeAmount };
    props.actions.walletRecharge({ url: ApiUrls.walletRecharge(), data: data }).then(
      res => {
        if (res.status == 200) {
          setSelectedView('map');
        }
      },
      err => {},
    );
  };

  const rechargeRequest = () => {
    if (!rechargeAmount) {
      setAmountError({
        message: 'VALIDATIONS.ENTER_ONLY_NUMBERS',
      });
    } else if (!CommonService.onlyNumericValues(rechargeAmount)) {
      setAmountError({
        message: 'VALIDATIONS.ENTER_ONLY_NUMBERS',
      });
    } else if (rechargeAmount > 200000) {
      setAmountError({
        message: 'RESULTS_PAGE.MAX_RECHARGE_AMOUNT',
      });
    } else {
      setShowModalInitial(true);
      setModalTitle('PROFILE.ALMOST_READY');
      setModalSubtitle('PROFILE.REC_IN_PROCESS');
      setModalBody('PROFILE.NEAR_POINT_TO_FINALIZE');
      setModalIcon('/static/images/booking-success-circle.png');
      setModalButtonText('OK, CONTINUAR');
    }

    // !rechargeAmount
    //   ? setAmountError({
    //       message: 'VALIDATIONS.ENTER_ONLY_NUMBERS',
    //     })
    //   : !CommonService.onlyNumericValues(rechargeAmount)
    //   ? setAmountError({
    //       message: 'VALIDATIONS.ENTER_ONLY_NUMBERS',
    //     })
    //   : rechargeAmount > 200000
    //   ? setAmountError({
    //       message: 'RESULTS_PAGE.MAX_RECHARGE_AMOUNT',
    //     })
    //   : // : this.setState({
    //     //     showModalInitial: true,
    //     //     modalTitle: 'PROFILE.ALMOST_READY',
    //     //     modalSubtitle: 'PROFILE.REC_IN_PROCESS',
    //     //     modalBody: 'PROFILE.NEAR_POINT_TO_FINALIZE',
    //     //     modalIcon: '/static/images/booking-success-circle.png',
    //     //     modalButtonText: 'OK, CONTINUAR',
    //     //   });
    //     setShowModalInitial(true);
    // setModalTitle('PROFILE.ALMOST_READY');
    // setModalSubtitle('PROFILE.REC_IN_PROCESS');
    // setModalBody('PROFILE.NEAR_POINT_TO_FINALIZE');
    // setModalIcon('/static/images/booking-success-circle.png');
    // setModalButtonText('OK, CONTINUAR');
  };

  const onRechargeAmountChange = val => {
    if (CommonService.onlyNumericValues(val)) {
      setAmountError(null);
      setRechargeAmount(CommonService.onlyNumbers(val));
    } else {
      setAmountError({
        message: 'VALIDATIONS.ENTER_ONLY_NUMBERS',
      });
      setRechargeAmount(CommonService.onlyNumbers(val));
    }
  };

  const { t } = props;
  return (
    <div id="sub-body-my-account" className="my-account-recharge-wallet-kupospay-recharge">
      <div className="recharge-map-container">
        <div className="white-triangle recharge-tab"></div>
        {selectedView === 'map' ? (
          <div className="recharge-wallet-top-strip">
            <div onClick={() => setSelectedView('steps')}>
              <img src="/static/images/back_arrow_bip.png" />
            </div>
            <div>
              <div className="title-and-image">
                <span>
                  {t('PROFILE.RECHARGE_YOUR')} &nbsp;
                  <img
                    style={{
                      height: 18,
                      marginTop: 5,
                    }}
                    src="/static/images/pullman/Home/pullmanPay.svg"
                    alt=""
                  />
                </span>
              </div>
              <div className="sub-section-description-description font11">
                <span>{t('PROFILE.RECHARGE_DESCRIPTION')}</span>
              </div>
            </div>

            <div></div>
          </div>
        ) : (
          <div>
            <div className="title-and-image">
              <span>
                {t('PROFILE.RECHARGE_YOUR')} &nbsp;
                <img
                  style={{
                    marginTop: 5,
                    height: 18,
                  }}
                  src="/static/images/pullman/Home/pullmanPay.svg"
                  alt=""
                />
              </span>
            </div>
            <div className="sub-section-description-description font11">
              <span>{t('PROFILE.RECHARGE_DESCRIPTION')}</span>
            </div>
          </div>
        )}
        { props.profileData && !props.profileData.is_kupos_pay_enabled && <Tabs t={t} selectedTab={selectedTab} onTabChange={onTabChange} operator={props.operator} /> }
        <div className="recharge-content">
          {selectedTab == 1 ? (
            selectedView == 'map' ? (
              <Map
                t={t}
                actions={props.actions}
                myLocation={myLocation}
                operator={props.operator}
                getRechargeLocations={props.actions.getRechargeLocations}
              />
            ) : (
              <Steps
                t={t}
                rechargeAmount={rechargeAmount}
                onRechargeAmountChange={onRechargeAmountChange}
                amountError={amountError}
                rechargeRequest={rechargeRequest}
                showMap={showMap}
                data={props.data}
                operator={props.operator}
              />
            )
          ) : (
            <BankTransfer t={t} operator={props.operator} />
          )}
        </div>
      </div>
      <SuccessModal
        showModal={showModal}
        setShowModal={setShowModal}
        setTransferStatus={setTransferStatus}
        setSelectedView={setSelectedView}
        setRechargeAmount={setRechargeAmount}
        transferStatus={transferStatus}
      />

      <KuposErrorSuccessModal
        showModal={showModalInitial}
        onHide={() => setShowModalInitial(false)}
        onButtonClick={() => goToMap()}
        success={true}
        t={t}
        showMyTitle={true}
        title="PROFILE.ALMOST_READY"
        subTitle="PROFILE.REC_IN_PROCESS"
        bodyText="PROFILE.NEAR_POINT_TO_FINALIZE"
        operator={props.operator}
      />
    </div>
  );
}

export default RechargeWalletKuposPayRecharge;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/RechargeWalletKupospayRecharge.js